// Import icons from react-icons
// You can import these at the top of any component that uses them
// import { SiC, SiCplusplus, SiPython, SiJava, SiJavascript, etc. } from 'react-icons/si';

export const programmingSkills = [
  { name: "C", icon: "SiC" },
  { name: "Python", icon: "SiPython" },
  { name: "Java", icon: "DiJava" },
  { name: "JavaScript", icon: "SiJavascript" },
];

export const frontendSkills = [
  { name: "HTML", icon: "SiHtml5" },
  { name: "CSS", icon: "SiCss3" },
  { name: "React", icon: "SiReact" },
  { name: "Bootstrap", icon: "SiBootstrap" },
  { name: "Tailwind", icon: "SiTailwindcss" },
  { name: "Figma", icon: "SiFigma" },
  { name: "Canva", icon: "SiCanva" },
];

export const backendSkills = [
  { name: "Node.js", icon: "SiNodedotjs" },
  { name: "MongoDB", icon: "SiMongodb" },
  { name: "SQL", icon: "SiMysql" },
  { name: "Postman", icon: "SiPostman" },
  { name: "AWS", icon: "SiAmazonwebservices" },
  { name: "Git", icon: "SiGit" },
  { name: "GitHub", icon: "SiGithub" },
];

export const projectsData = [
  {
    image:
      "https://raw.githubusercontent.com/kuruvapavani/portfolio-media/refs/heads/main/projects/memora.png",
    title: "Memora",
    stack: [
      "MERN Stack",
      "Tailwind",
      "React-three-fiber",
      "Cloudinary",
      "Firebase",
    ],
    demoLink: "https://memora-kp.vercel.app/",
    codeLink: "https://github.com/kuruvapavani/Memora.git",
  },
  {
    image:
      "https://raw.githubusercontent.com/kuruvapavani/portfolio-media/refs/heads/main/projects/pizzacrave.png",
    title: "PizzaCrave",
    stack: ["MERN", "Tailwind CSS", "Stripe (Test)", "JWT Auth", "Nodemailer"],
    demoLink: "https://pizzacrave.vercel.app/",
    codeLink: "https://github.com/kuruvapavani/pizzacrave",
  },
  {
    image:
      "https://raw.githubusercontent.com/kuruvapavani/portfolio-media/refs/heads/main/projects/mern-blog.png",
    title: "Blog Site",
    stack: ["MERN Stack"],
    demoLink: "https://mern-blog-kp.vercel.app/",
    codeLink: "https://github.com/kuruvapavani/mern-blog.git",
  },
  {
    image:
      "https://raw.githubusercontent.com/kuruvapavani/portfolio-media/refs/heads/main/projects/portfolio.png",
    title: "3D Portfolio Website",
    stack: ["MERN Stack", "React Three Fiber"],
    demoLink: "https://kuruva-pavani.netlify.app",
    codeLink: "https://github.com/kuruvapavani/mern-portfolio",
  },
  {
    image:
      "https://raw.githubusercontent.com/kuruvapavani/portfolio-media/refs/heads/main/projects/to-do-list.png",
    title: "To Do List",
    stack: ["EJS", "Node.Js", "MongoDB", "Express.js"],
    demoLink:
      "https://kuruvapavani-to-do-list.onrender.com/Saturday,%20october%205",
    codeLink: "https://github.com/kuruvapavani/to-do-list",
  },
  {
    image:
      "https://raw.githubusercontent.com/kuruvapavani/portfolio-media/refs/heads/main/projects/drum-kit.png",
    title: "Drum Kit",
    stack: ["HTML", "CSS", "JavaScript"],
    demoLink: "https://kuruvapavani.github.io/Drum_Kit/",
    codeLink: "https://github.com/kuruvapavani/Drum_Kit.git",
  },
  {
    image:
      "https://raw.githubusercontent.com/kuruvapavani/portfolio-media/refs/heads/main/projects/dice-game.png",
    title: "Dice Game",
    stack: ["HTML", "CSS", "JavaScript"],
    demoLink: "https://kuruvapavani.github.io/Dice_Game/",
    codeLink: "https://github.com/kuruvapavani/Dice_Game.git",
  },
  {
    image:
      "https://raw.githubusercontent.com/kuruvapavani/portfolio-media/refs/heads/main/projects/rock-paper-scissors.png",
    title: "Rock Paper Scissors",
    stack: ["HTML", "CSS", "JavaScript"],
    demoLink: "https://kuruvapavani.github.io/Rock_Paper_Scissors_Game/",
    codeLink: "https://github.com/kuruvapavani/Rock_Paper_Scissors_Game.git",
  },
];

export const experienceData = [
  {
    position: "Web Developer Club Coordinator",
    company: "IIITT",
    image:
      "https://iiitt.ac.in/_next/image?url=%2Fimages%2Fwebdevclub.jpg&w=256&q=75",
    blogLink: "https://iiitt.ac.in/clubs",
  },
  {
    position: "Web Developer Intern",
    company: "Robosmic",
    image:
      "https://raw.githubusercontent.com/kuruvapavani/portfolio-media/refs/heads/main/experience/robosmic.jpg",
    blogLink:
      "https://www.linkedin.com/posts/kuruva-pavani-2109k_internship-webdevelopment-react-activity-7245474964269629440-7SoK?utm_source=share&utm_medium=member_desktop",
  },
];

export const typingTexts = [
  "I build full-stack MERN applications",
  "I design scalable backend systems",
  "I solve complex DSA problems",
  "I create optimized web solutions",
];
